import React, { useContext, useState, useEffect } from 'react';
import { Button, SuccessButton } from '../connectedForm/Button';
import Dropdown from '../connectedForm/Dropdown';
import { MaxoptraOrderPriority, Maybe } from '../../graphql/schema/p4types';
import { ModalBottomButtonContainer } from './Styles';
import { BasicHeader } from '../../actions/BasicHeader';
import WorkspaceContext from '../Context/WorkspaceContext';
import FluentModal from './FluentModal';
import fieldMetaData, { IEnumMeta } from '../../graphql/schema/fieldMetaData';
import { useNotifyMaxoptraAction } from '../../actions/sales/SalesOrderWorkspaceAction';
import DateInput from '../connectedForm/DateInput/DateInput';
import { useSalesOrderConfig } from '../../utils/FetchConfig';

const RescheduleOrdersModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const { selectionState } = useContext(WorkspaceContext);
  const [effectiveOrderDate, setEffectiveOrderDate] = useState<Maybe<string>>();
  const orderConfig = useSalesOrderConfig();
  const defaultPriority = fieldMetaData.MaxoptraOrderPriority.enumValues.find(
    (option) => option.value === MaxoptraOrderPriority.High
  );

  const [maxoptraOrderPriority, setMaxoptraOrderPriority] = useState<IEnumMeta<MaxoptraOrderPriority>>(
    defaultPriority!
  );

  const [notifyMaxoptraAction, notifyMaxoptraModals] = useNotifyMaxoptraAction(
    maxoptraOrderPriority.value!,
    effectiveOrderDate
  );

  const handleRescheduleOnClick = (e: React.MouseEvent<HTMLElement>) => {
    notifyMaxoptraAction?.onClick?.(e);
    onClose();
  };

  const title = selectionState?.count ? `Reschedule Orders (${selectionState.count} selected)` : 'Reschedule Orders';

  // reset fields between uses of the modal
  useEffect(() => {
    if (isOpen) {
      setEffectiveOrderDate(null);
      setMaxoptraOrderPriority(defaultPriority!);
    }
  }, [isOpen]);

  return (
    <>
      <FluentModal isOpen={isOpen} styles={{ main: { paddingBottom: '60px', minWidth: '400px' } }}>
        <BasicHeader>{title}</BasicHeader>
        <div style={{ padding: '1em' }}>
          <Dropdown
            labelCols={0.5}
            inputCols={0.5}
            label="Maxoptra Order Priority"
            data-testid="maxoptra-order-priority"
            value={maxoptraOrderPriority}
            onChange={setMaxoptraOrderPriority}
            options={fieldMetaData.MaxoptraOrderPriority.enumValues}
            clearable={false}
          />
          {orderConfig?.autoAssignDeliveryDate && (
            <DateInput
              labelCols={0.5}
              inputCols={0.5}
              data-testid="effective-order-date"
              label="Effective Order Date"
              placeholder={'Purchase Invoices From'}
              onChange={setEffectiveOrderDate}
              value={effectiveOrderDate}
              hint={'If entered, Expected Delivery Date will be recalculated from it'}
            />
          )}
        </div>
        <ModalBottomButtonContainer>
          <Button data-testid="reschedul-orders-modal-cancel" onClick={onClose}>
            Cancel
          </Button>
          <SuccessButton data-testid="reschedule-orders-modal-reschedule" onClick={handleRescheduleOnClick}>
            Reschedule
          </SuccessButton>
        </ModalBottomButtonContainer>
      </FluentModal>
      {notifyMaxoptraModals}
    </>
  );
};

export default RescheduleOrdersModal;
